module.exports = __webpack_public_path__ + "img/3.2b8b0b0f.png";